import { Clock, Mail, MapPin, Phone } from "lucide-react";

function telHref(phone) {
  return `tel:${(phone || "").replace(/[^0-9+]/g, "")}`;
}

export default function Contact({ content }) {
  const c1 = {
    name: content?.contact1_name || "Jose L. Duran",
    role: content?.contact1_role || "Landscape Designer",
    phone: content?.contact1_phone || "214-576-8224",
    email: content?.contact1_email || "somozaslandscaping@outlook.com",
  };
  const c2 = {
    name: content?.contact2_name || "Alberto Somoza",
    role: content?.contact2_role || "Manager",
    phone: content?.contact2_phone || "972-703-3267",
    email: content?.contact2_email || "somozaslandscapingllc@gmail.com",
  };

  return (
    <section id="contact" data-testid="contact-section" className="py-20 md:py-28 px-4 sm:px-6 lg:px-8 scroll-mt-20">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-2xl">
          <span className="text-brand font-bold uppercase tracking-widest text-sm">Contact</span>
          <h2 className="mt-3 font-heading font-bold text-ink text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-snug">
            Talk to Our Team
          </h2>
          <div className="mt-5 h-1.5 w-24 bg-brand rounded-full" aria-hidden="true" />
          <p className="mt-4 text-[#4B5563] text-lg leading-relaxed">
            Call, text, or email — or send us the free estimate form and we will reach out to you.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl">
          {[c1, c2].map((person, i) => (
            <article
              key={person.email}
              data-testid={`contact-card-${i + 1}`}
              className="bg-white border border-border rounded-xl p-8 hover:shadow-md transition-shadow duration-200"
            >
              <h3 className="font-heading font-bold text-ink text-xl">{person.name}</h3>
              <p className="text-forest font-medium text-sm mt-1">{person.role}</p>
              <div className="mt-6 flex flex-col gap-3">
                <a
                  href={telHref(person.phone)}
                  data-testid={`contact-call-button-${i + 1}`}
                  className="inline-flex items-center justify-center gap-2 bg-brand text-white font-semibold rounded-full px-6 py-3 hover:bg-brand-hover transition-colors duration-200"
                >
                  <Phone className="w-4 h-4" aria-hidden="true" />
                  {person.phone}
                </a>
                <a
                  href={`mailto:${person.email}`}
                  data-testid={`contact-email-link-${i + 1}`}
                  className="inline-flex items-center justify-center gap-2 border-2 border-forest text-forest font-semibold rounded-full px-6 py-3 hover:bg-forest hover:text-white transition-colors duration-200 text-sm break-all"
                >
                  <Mail className="w-4 h-4 shrink-0" aria-hidden="true" />
                  {person.email}
                </a>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-4xl">
          <div className="bg-brand-light rounded-xl p-6 flex items-start gap-4" data-testid="contact-hours">
            <Clock className="w-6 h-6 text-brand shrink-0 mt-0.5" aria-hidden="true" />
            <div>
              <h3 className="font-heading font-semibold text-ink">Business Hours</h3>
              {(() => {
                const raw = content?.business_hours || "Call us for current hours";
                const [main, ...rest] = raw.split("·");
                return (
                  <>
                    <p className="text-[#4B5563] text-sm mt-1">{main.trim()}</p>
                    {rest.length > 0 && (
                      <p className="text-brand text-sm font-medium mt-0.5">{rest.join("·").trim()}</p>
                    )}
                  </>
                );
              })()}
            </div>
          </div>
          <div className="bg-brand-light rounded-xl p-6 flex items-start gap-4" data-testid="contact-service-area">
            <MapPin className="w-6 h-6 text-brand shrink-0 mt-0.5" aria-hidden="true" />
            <div>
              <h3 className="font-heading font-semibold text-ink">Service Area</h3>
              <p className="text-[#4B5563] text-sm mt-1">{content?.service_area || "Dallas / DFW metro area"}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
